import React from 'react';
import { FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { FormikWrapper } from '@uncinc/uncinc-react-kitchen-sink';

import usePopup from '../../../../hooks/usePopup';
import BuddiesFormConfirmation from '../Confirmation';
import { BuddiesFormValues } from '../types';

interface Props {
  translationBase?: string;
  onSubmit: (values: BuddiesFormValues, helpers: FormikHelpers<BuddiesFormValues>) => void;
  children: React.ReactNode;
}

const BuddiesFormFormikWrapper: React.FC<Props> = (props) => {
  const {
    translationBase,
    children,
    onSubmit,
  } = props;

  const { t } = useTranslation();
  const popup = usePopup('add-buddy-confirmation');

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(t(`${translationBase}.fields.name.validation.required`)),
    email: Yup.string()
      .required(t(`${translationBase}.fields.email.validation.required`))
      .email(t(`${translationBase}.fields.email.validation.email`)),
  });

  return (
    <FormikWrapper
      initialValues={{ name: '', email: '' }}
      validationSchema={validationSchema}
      onSubmit={() => popup.open()}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {children}

      {popup.isOpen && (
        <BuddiesFormConfirmation {...popup} onSubmit={onSubmit} />
      )}
    </FormikWrapper>
  );
};

export default BuddiesFormFormikWrapper;
